import { IconType } from 'react-icons/lib';

const MapConversationIcon: React.FC<{ color?: string; height?: number; width?: number }> = ({
  color,
  height = 24,
  width = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_26374_124546)">
      <path
        d="M2 21.0004C1.99992 19.4608 2.44413 17.9538 3.27935 16.6603C4.11456 15.3669 5.30527 14.3419 6.7086 13.7085C8.11193 13.075 9.66824 12.8599 11.1908 13.0891C12.7133 13.3183 13.3453 13.4815 14.5 14.5"
        stroke={color ?? 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13C12.7614 13 15 10.7614 15 8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8C5 10.7614 7.23858 13 10 13Z"
        stroke={color ?? 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.57 16.98V24H18.86V19.79L17.29 24H15.91L14.33 19.78V24H12.62V16.98H14.64L16.61 21.84L18.56 16.98H20.57Z"
        fill={color ?? 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_26374_124546">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const MapConversationModIcon: IconType = () => <MapConversationIcon color="currentColor" />;

export default MapConversationIcon;
export { MapConversationModIcon };
